import { ADD_BOOK, DELETE_BOOK, SHOW_BOOKS, UPDATE_BOOK, CHANGE_OPERATION, SELECT_CANDIDATE } from "./actionsTypes";

export const showBooks = (books) => {
  return {
    type: SHOW_BOOKS,
    payload: books
  };
};

export const addBooks = (book) => {
  return {
    type: ADD_BOOK,
    payload: book
  };
};

export const updateBook = (book) => {
  return {
    type: UPDATE_BOOK,
    payload: book
  };
};

export const deleteBook = (id) => {
  return {
    type: DELETE_BOOK,
    payload: id
  };
};

export const changeOperation = (operation) => {
  return {
    type: CHANGE_OPERATION,
    payload: operation
  };
};

export const selectCandidate = (book) => {
  return {
    type: SELECT_CANDIDATE,
    payload: book
  };
};
